import { render, staticRenderFns } from "./OpeningTimeEditForm.vue?vue&type=template&id=02120b1c&lang=html&"
import script from "./OpeningTimeEditForm.vue?vue&type=script&lang=js&"
export * from "./OpeningTimeEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports